import type { NavigationItem } from '@/types/layout.types';
import { usePointerActivation } from '@/hooks';
import { cn } from '@/utils';

export function MobileBottomNavItem({
	item,
	icon: Icon,
	isActive,
	onNavigate,
}: {
	item: NavigationItem;
	icon: NavigationItem['icon'];
	isActive: boolean;
	onNavigate: (path: string) => void;
}) {
	const action = () => onNavigate(item.href!);
	const pointerProps = usePointerActivation(action);

	return (
		<button
			type="button"
			{...pointerProps}
			aria-current={isActive ? 'page' : undefined}
			aria-label={item.tabName}
			className="flex h-12 w-14 shrink-0 touch-manipulation items-center justify-center rounded-full focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-[#2667FF] focus-visible:ring-offset-2"
		>
			<Icon
				aria-hidden="true"
				className={cn(
					'h-6 w-6 transition-colors duration-200',
					isActive ? 'text-blue-custom-2' : 'text-[#414D73]'
				)}
			/>
		</button>
	);
}
